import React from 'react';
import { Modal } from 'react-bootstrap';
import FlipBook from './FlipBook';
import '../../sass/layout/flipbook/flipbook-modal.css';

const FlipBookModal = ({
  show,
  handleClose,
  pdfUrl,
  width = '100%',
  height = '80vh',
  className = ''
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      className="flipbook-modal"
    >
      <Modal.Body className="flipbook-modal-body">
        <button
          type="button"
          className="btn-close custom-close-button"
          aria-label="Close"
          onClick={handleClose}
        ></button>
        <FlipBook
          pdfUrl={pdfUrl}
          width={width}
          height={height}
          className={className}
        />
      </Modal.Body>
    </Modal>
  );
};

export default FlipBookModal;
